import { render, staticRenderFns } from "./goods-order-list.vue?vue&type=template&id=355b2e69&scoped=true"
import script from "./goods-order-list.vue?vue&type=script&lang=js"
export * from "./goods-order-list.vue?vue&type=script&lang=js"
import style0 from "./goods-order-list.vue?vue&type=style&index=0&id=355b2e69&prod&lang=scss"
import style1 from "./goods-order-list.vue?vue&type=style&index=1&id=355b2e69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355b2e69",
  null
  
)

export default component.exports